import collaborationNameProvider from './PropertiesProvider';

export default {
  __init__: [ 'collaborationNameProvider' ],
  collaborationNameProvider: [ 'type', collaborationNameProvider ]
};